<template>
    <el-dialog :title="allocateDialog.title" :visible.sync="allocateDialog.visible" width="60%" :close-on-click-modal="false" :before-close="closeAllocateDialog" custom-class="dialog-allocate" append-to-body>
        <div class="allocate-dialog-body">
            <div class="department-tree">
                <el-table :data="getTableData" style="width: 100%" height="465">
                    <el-table-column prop="realname" label="回访状态" width="80">
                        <template slot-scope="scope">
                            {{getActiveStauts(scope.row.member.active_status)}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="mobile" label="手机号">
                    </el-table-column>
                </el-table>
            </div>
            <div class="department-tree">
                <el-tree :data="tree" :props="defaultProps" node-key="id" default-expand-all @node-click=" getDepartmentUserList"></el-tree>
            </div>
            <div class="user-list-box">
                <el-form ref="userSearch" :model="userSearch" :inline="true" label-width="80px" @submit.native.prevent>
                    <el-form-item>
                        <el-select v-model="userSearch.hotel_id" filterable clearable placeholder="请选择酒店">
                            <el-option v-for="(item, key) in hotelList" :key="key" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="userSearch.keyword" clearable clear="searchUser" placeholder="用户名或者昵称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" native-type="submit" @click="searchUser">搜索</el-button>
                    </el-form-item>
                </el-form>
                <div class="tag-box" v-if="capitalPeople.length>0">
                    已选择：<el-tag class="tag-item" v-for="(i,index) in capitalPeople" @close="removeUser(i,index)" closable :key="index">
                        {{i.user_name}}</el-tag>
                </div>
                <el-table height="300" :data="userTableData" ref="userTable" @selection-change="handleUserChange" style="width: 100%;">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <el-table-column prop="department" label="部门"></el-table-column>
                    <el-table-column prop="realname" label="真实姓名"></el-table-column>
                </el-table>
                <div slot="footer" class="dialog-footer">
                    <div>
                        <el-button @click="closeAllocateDialog">取 消</el-button>
                        <el-button type="primary" @click="doAllocate">分 配</el-button>
                    </div>
                    <div>
                        <el-button type="success" @click="doCompleted">全部重复客资已分配完成</el-button>
                    </div>
                </div>
            </div>
        </div>

    </el-dialog>
</template>
<script>
import dictionary from '@/utils/dictionary.js';

export default {
    props: {
        parent: {},
    },
    data() {
        return {
            //分配客资s
            allocateDialog: {
                //分配客资弹窗
                titie: '分配客资',
                visible: false
            },
            departmentTree: [], //部门树
            // 分配客资公司树
            tree: [],
            // tree 默认节点
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            // 弹框搜索
            userSearch: {
                hotel_id: '',
                keyword: ''
            },
            userTableData: [],
            capitalPeople: [], //分配客资（人）
            allocate: [],
            getTableData: [],
            upload_file_id: ''
        }

    },
    computed: {
        hotelList: () => {
            return dictionary.getPicker('hotel');
        },
        // 回访状态
        activeStatusList: () => {
            return dictionary.getPicker('active_status'); // this 指向的是windows
        },
    },
    methods: {
        getActiveStauts(id) {
            let _this = this;
            let activeStatusList = _this.activeStatusList;
            let arr = Object.values(activeStatusList)
            let target = arr.find(ele => ele.id == id);
            return target ? target['title'] : '-';
        },
        // 显示弹窗
        showDialog(allocateForm, query, row, type) {
            console.log(allocateForm, query, type)
            let _this = this;
            _this.allocateDialog.visible = true;
            _this.allocateIds = allocateForm.ids;
            _this.getDepartmentTree();
            _this.getTree();
            _this.capitalPeople = [];
            _this.userTableData = []
            _this.getTableData = allocateForm.allocateRow
            _this.upload_file_id = row.id
            if (type == 'duplicate') {
                _this.allocateDialog.title = '分配重复客资'
            }

        },
        //分配完成
        doCompleted() {
            let url = '/api/customer.distribution/setAllocatedStatus';
            let that = this;
            this.$post(url, { id: that.upload_file_id }).then(function (response) {
                if (response.code == 200) {
                    that.$message({
                        message: response.msg,
                        type: 'success'
                    });
                    that.closeAllocateDialog();
                    that.$parent.$parent.closeAllocateDialog()
                    that.$parent.$parent.getTableData()
                }
            });
        },
        //分配客资提交
        doAllocate() {
            let that = this;
            if (this.capitalPeople.length == 0) {
                this.capitalPeople = [];
                this.$message({
                    message: '请选择要分配的客资',
                    type: 'warning'
                });
                return false;
            }
            this.$post('/api/customer.distribution/doAllocateDuplicate', {
                staffs: that.capitalPeople,
                ids: that.allocateIds,
                upload_file_id: that.upload_file_id
            }).then(function (response) {
                if (response.code == 200) {
                    that.$message({
                        message: response.msg,
                        type: 'success'
                    });
                    // that.closeAllocateDialog();
                    // that.$parent.$parent.closeAllocateDialog()
                    that.$parent.$parent.getTableData()
                } else {
                    that.$message({
                        message: response.msg,
                        type: 'error'
                    });
                }
            });
        },
        closeAllocateDialog() {
            _this.allocateDialog.visible = false;
        },
        //获取分配客资的人
        handleUserChange(e) {
            let _this = this;
            let selectPeople = e;
            let capitalPeople = _this.capitalPeople;
            selectPeople.map((row, key) => {
                let userid = capitalPeople.find(ele => {
                    return ele.user_id == row.id
                })
                if (!userid) {
                    _this.capitalPeople.push({
                        user_name: row.realname,
                        user_id: row.id
                    })
                }

            })
        },
        // 关闭分配客资
        closeAllocateDialog() {
            this.allocateDialog.visible = false;
        },
        // 获取部门树
        getDepartmentTree() {
            let url = '/api/ucenter.department/getDepartmentTree';
            let that = this;
            this.$post(url, {}).then(function (response) {
                that.departmentTree = response.data.tree;
            });
        },
        // 获取Tree数据
        getTree() {
            let url = '/api/ucenter.department/getTreeById';
            let that = this;
            let query = {
                id: 83
            };
            this.$post(url, query).then(function (response) {
                that.tree = response.data.tree;
            });
        },
        // tree 获取部门下的所有员工
        getDepartmentUserList(e) {
            let that = this;
            let url = '/api/ucenter.user/getDepartmentUserList';
            let query = {
                id: e.id
            };
            // 添加或编辑客资信息
            that.$post(url, query).then(function (response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.userTableData = response.data.list;
                }
            });
        },
        // 搜索用户
        searchUser() {
            let that = this;
            let url = '/api/ucenter.user/getDepartmentUserList';
            // 添加或编辑客资信息
            that.$post(url, this.userSearch).then(function (response) {
                if (response.code != '200') {
                    that.$message.error(response.msg);
                } else {
                    that.userTableData = response.data.list;
                }
            });
        },
        // 移除人员
        removeUser(row, index) {
            let _this = this;
            _this.capitalPeople.splice(index, 1);
        },
    }
}
</script>
<style lang="less" scoped>
/deep/.el-dialog__body {
    margin: 0 20px 10px 20px;
    padding: 0;
    padding-bottom: 20px;
}
.dialog-allocate .department-tree {
    flex: 0 20%;
    border-right: 1px solid #dedede;
    overflow: auto;
}
.tag-box {
    margin-bottom: 10px;
    .tag-item {
        margin-right: 5px;
        margin-bottom: 2px;
    }
}
.allocate-dialog-body {
    height: 50vh;
}
.dialog-footer {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 12px;
    display: flex;
    justify-content: space-between;
}
</style>